(function () {
  function init(root) {
    if (!root || root.__wmKnifeInit) return;
    root.__wmKnifeInit = true;

    var state = { use: null, style: null, focus: null };
    var btnShow = root.querySelector('[data-wm-show-result]');
    var hint = root.querySelector('[data-wm-hint]');
    var summary = root.querySelector('[data-wm-summary]');
    var note = root.querySelector('[data-wm-note]');
    var out = root.querySelector('[data-wm-productwrap]');

    function setPressed(group, value) {
      root.querySelectorAll('.wm-choice[data-group="'+group+'"]').forEach(function(b){
        b.setAttribute('aria-pressed', b.dataset.value === value ? 'true' : 'false');
      });
    }

    function enableState() {
      var ok = !!(state.use && state.style && state.focus);
      if (btnShow) btnShow.disabled = !ok;
      if (hint) hint.textContent = ok ? 'Perfekt – Empfehlung anzeigen.' : 'Bitte wähle je eine Option pro Frage.';
      return ok;
    }

    function pickKey() {
      var use = state.use;
      var style = state.style;
      var focus = state.focus;

      // Serie-Logik: "special" -> FlameWood (mehr Spezialmesser), "one" -> NaturalWood (klassischer Einstieg)
      var series = (focus === 'special') ? 'fw' : 'nw';

      // Harte Spezialfälle
      if (use === 'fisch') return 'fw-filetier';       // nur FlameWood
      if (use === 'fein') return 'fw-office';          // nur FlameWood

      // Brot: je nach series
      if (use === 'brot') return (series === 'fw') ? 'fw-brot' : 'nw-brot';

      // Wenn Wiegeschnitt: Chefmesser (klassisch)
      if (style === 'rock') return (series === 'fw') ? 'fw-chef' : 'nw-chef';

      // Gemüse: Nakiri wenn Spezial ok, sonst Santoku
      if (use === 'gemuese') {
        if (focus === 'special') return 'fw-nakiri';
        return 'nw-santoku';
      }

      // Fleisch/Braten: Chefmesser ist am universellsten
      if (use === 'fleisch') return (series === 'fw') ? 'fw-chef' : 'nw-chef';

      // Allround: Santoku (Push/Mix), Chef (Rock)
      if (use === 'allround') {
        if (style === 'push') return (series === 'fw') ? 'fw-santoku' : 'nw-santoku';
        return (series === 'fw') ? 'fw-santoku' : 'nw-santoku';
      }

      // Default
      return (series === 'fw') ? 'fw-santoku' : 'nw-santoku';
    }

    function findTemplate(key) {
      var catalog = root.querySelector('[data-wm-catalog]');
      if (!catalog) return null;
      return catalog.querySelector('template[data-wm-item][data-key="'+key+'"]') || null;
    }

    function showResult() {
      if (!enableState()) return;

      var key = pickKey();
      var tpl = findTemplate(key);

      out.innerHTML = '';
      if (tpl && tpl.content) out.appendChild(tpl.content.cloneNode(true));
      else out.innerHTML = '<p>Empfehlung konnte nicht geladen werden. Prüfe bitte, ob das Produkt aktiv ist.</p>';

      if (summary) {
        summary.textContent =
          'Auswahl: ' +
          (state.use || '—') + ' · ' +
          (state.style || '—') + ' · ' +
          (state.focus || '—');
      }

      if (note) {
        note.hidden = false;
        if (key === 'fw-filetier') note.textContent = 'Für Fisch & Filet ist ein flexibles Filetiermesser die sauberste Lösung – weniger Reißen, mehr Kontrolle.';
        else if (key === 'fw-office') note.textContent = 'Für Feinarbeit ist ein kleines Officemesser unschlagbar: schnell, präzise, immer griffbereit.';
        else if (key.indexOf('nakiri') > -1) note.textContent = 'Nakiri ist das Gemüse-Arbeitstier: Push-Cut, saubere Würfel, extrem effizient bei viel Prep.';
        else if (key.indexOf('chef') > -1) note.textContent = 'Chefmesser ist der Klassiker, wenn du gern wiegst oder ein echtes Allround-Arbeitsmesser willst.';
        else if (key.indexOf('santoku') > -1) note.textContent = 'Santoku ist der Allrounder für Push-Cut und gemischte Aufgaben – sehr beliebt für Alltag & Prep.';
        else if (key.indexOf('brot') > -1) note.textContent = 'Brotmesser: saubere Schnitte durch Kruste – ohne Drücken oder Quetschen.';
        else note.textContent = 'Tipp: Wenn du später erweitern willst, ist ein Spezialmesser (Nakiri/Office/Filet) der schnellste Upgrade-Schritt.';
      }
    }

    function resetAll() {
      state.use = null; state.style = null; state.focus = null;
      root.querySelectorAll('.wm-choice').forEach(function(b){ b.setAttribute('aria-pressed','false'); });
      if (summary) summary.textContent = 'Wähle oben deine Optionen – dann zeigen wir dir das passende Messer.';
      if (note) { note.hidden = true; note.textContent = ''; }
      if (out) out.innerHTML = '';
      enableState();
    }

    root.addEventListener('click', function(e){
      var c = e.target.closest('.wm-choice');
      if (c) {
        state[c.dataset.group] = c.dataset.value;
        setPressed(c.dataset.group, c.dataset.value);
        enableState();
        return;
      }
      if (e.target.closest('[data-wm-show-result]')) { showResult(); return; }
      if (e.target.closest('[data-wm-reset]')) { resetAll(); return; }
    });

    resetAll();
  }

  function boot() {
    document.querySelectorAll('[data-wm-knife-finder]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function(ev){
    if (ev && ev.target) {
      var r = ev.target.querySelector('[data-wm-knife-finder]');
      init(r);
    }
  });
})();